import React, { useEffect, useState } from 'react';
import { Container, Title, Input, Button, ErrorMessage } from '../styles.js'; 
import { auth, database } from '../../../config/firebase.js'; 
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc, setDoc, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore'; 
import { useNavigate } from 'react-router-dom';
import Load from '../../../components/load/index.js';
import { getErroMessage } from '../messages-erro.js';
import CryptoJS from 'crypto-js';

const Register = ({ loadingUser, codeParam }) => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(()=>{
    if (codeParam) {
      setCode(codeParam)
    }
  }, [ codeParam ]);

  const encryptPassword = (password) => {
    return CryptoJS.AES.encrypt(password, 'fds18102004').toString();
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const codeDocRef = doc(database, 'codes_members', code);
      const codeDoc = await getDoc(codeDocRef);

      // Verifica se o código existe
      if (!codeDoc.exists()) {
        setError('O código fornecido é inválido ou não existe.');
        setIsLoading(false);
        setTimeout(() => {
          setError('');
        }, 3000);
        return;
      }

      // Criação do usuário
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;

      const userData = {
        account_name: fullName,
        account_email: email,
        account_uid: uid,
        account_description: "Membro PRO",
        account_type_name: "Membro PRO",
        account_type: "member_pro",
        account_member_until: codeDoc.data().account_member_until,
        account_member_since: serverTimestamp(),
        code: code
      };

      // Armazenar dados do usuário no Firestore
      await setDoc(doc(database, 'members', uid), userData);
      
      const encryptedPassword = encryptPassword(password);

      await setDoc(doc(database, 'users', uid), {
        account_name: fullName,
        account_email: email,
        account_uid: uid,
        account_password: encryptedPassword,
        account_created: serverTimestamp(),
      });

      // Gerar novo código de 4 dígitos
      const newCode = Math.floor(1000 + Math.random() * 9000).toString(); // Gera um novo código

      // Excluir o código antigo e adicionar o novo
      await deleteDoc(codeDocRef); // Exclui o código existente
      await setDoc(doc(database, 'codes_members', newCode), { 
        account_member_until: codeDoc.data().account_member_until, // Mantenha outras informações se necessário
        code: newCode
      });

      navigate('/profiles');
      
    } catch (error) {
      console.error('Erro ao registrar:', error);

      // Verificar o código de erro retornado pelo Firebase
      switch (error.code) {
        case 'auth/email-already-in-use':
          setError('Este email já está cadastrado. Tente outro.');
          break;
        case 'auth/weak-password':
          setError('A senha deve ter pelo menos 6 caracteres.');
          break;
        default:
          setError('Ocorreu um erro ao tentar registrar. Tente novamente mais tarde.');
          break;
      }

      getErroMessage(error.code, setError);
      
      setTimeout(() => {
        setError('');
      }, 5000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      {loadingUser || isLoading ? (
        <Load />
      ) : (
        <>
          <Title>Registrar-se</Title>
          <form onSubmit={handleRegister}>
            <label htmlFor="fullName">Nome Completo</label>
            <Input
              type="text"
              id="fullName"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
            <label htmlFor="email">Email</label>
            <Input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="password">Senha</label>
            <Input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {!codeParam && (
              <>
                <label htmlFor="code">Código</label>
                <Input
                  type="text"
                  id="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
              </>
            )}
            <Button type="submit">Registrar</Button>
            {error && <ErrorMessage><i className='fas fa-exclamation-triangle'></i> {error}</ErrorMessage>}
          </form>
        </>
      )}
    </Container>
  );
};

export default Register;
